module.exports = __webpack_public_path__ + "img/icon-list.7b919d14.svg";